import { render } from "./ProcessingCommentsField.vue?vue&type=template&id=0d459922"
import script from "./ProcessingCommentsField.vue?vue&type=script&lang=js"
export * from "./ProcessingCommentsField.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__